var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquares({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H5.22414C6.05256 0 6.72414 0.671573 6.72414 1.5V5.22414C6.72414 6.05256 6.05256 6.72414 5.22414 6.72414H1.5C0.671573 6.72414 0 6.05256 0 5.22414V1.5ZM1.5 1.5H5.22414L5.22414 5.22414L1.5 5.22414L1.5 1.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.77586C0 8.94744 0.671573 8.27586 1.5 8.27586H5.22414C6.05256 8.27586 6.72414 8.94743 6.72414 9.77586V13.5C6.72414 14.3284 6.05256 15 5.22414 15H1.5C0.671573 15 0 14.3284 0 13.5V9.77586ZM1.5 9.77586H5.22414L5.22414 13.5L1.5 13.5L1.5 9.77586Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77586 0C8.94743 0 8.27586 0.671573 8.27586 1.5V5.22414C8.27586 6.05256 8.94744 6.72414 9.77586 6.72414H13.5C14.3284 6.72414 15 6.05256 15 5.22414V1.5C15 0.671573 14.3284 0 13.5 0H9.77586ZM13.5 1.5H9.77586V5.22414L13.5 5.22414L13.5 1.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27586 9.77586C8.27586 8.94744 8.94743 8.27586 9.77586 8.27586H13.5C14.3284 8.27586 15 8.94743 15 9.77586V13.5C15 14.3284 14.3284 15 13.5 15H9.77586C8.94744 15 8.27586 14.3284 8.27586 13.5V9.77586ZM9.77586 9.77586H13.5L13.5 13.5L9.77586 13.5V9.77586Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.4d2b8bfe3a96e5bc635e33c1f3fde583.svg";
export { ForwardRef as ReactComponent };